import React, {useState, useRef, useEffect} from 'react';
import {HeadTitle, Heading} from '../Typography2';
import {EnterPin} from '../../services/api';
import Button from '../Button';
import {useSelector} from 'react-redux';
import PairVrForm from './Form';
import CreateAvatar from './CreateAvatar';

const initialState = {
    firstNum: '',
    secondNum: '',
    thirdNum: '',
    forthNum: '',
}

const PairVr = (props) => {
    const [isInvalid, setInvalid] = useState(false);
    const [code, setCode] = useState(initialState);
    const [success, setSuccess] = useState(false);
    const inputsNames = Object.keys(initialState);
    const inputRefs = useRef(new Array());
    const buttonRef = useRef<HTMLButtonElement>(null);
    const finalIndex = inputsNames.length - 1;

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        if (value && value.trim() !== "") {
            const index = inputsNames.indexOf(name);
            setCode({
                ...code,
                [name]: value
            })
            if (index < finalIndex) {
                inputRefs.current[index + 1].focus();
            } else {
                buttonRef.current.focus();
            }
        }
    }

    const handleSubmit = async () => {
            const pin = Object.values(code).join('');
            const resp = await EnterPin({pin})
            if (resp) {
                setSuccess(true);
            } else {
                setInvalid(!isInvalid)
            }
    }

    const handleFocus = (event) => event.target.select();

    return (
        <section className="pairvr-wrapper">
            {props.isLoggedIn ? <div className="pairvr">
                {!success ? (
                      
                        <>
                            <CreateAvatar />
                        </>
                    )
                    :
                    <>
                        <HeadTitle value="You’re good to go"/>
                        <Heading value="Please put on your headset to continue"/>
                    </>
                }
            </div> : 
            <>
                <PairVrForm />
            </>
            }
        </section>
    )
}

export default PairVr
